import React, { useState } from 'react';
import { Tournament } from '@la/types';
import { useRegistrationAddOns } from 'redux/hooks/useRegistrationAddOns';
import AddOnsModal from '../AddOnsModal/AddOnsModal';
import {
  FeesSidebarCardProps,
  RegistrationFeeData,
} from '../TournamentDetails.types';
import {
  compileRegistrationFeesData,
  convertRegFeesToNumbers,
} from '../utils/feeCalculationUtils';
import { buildFees } from '../utils/fees';
import styles from './TournamentFeesSidebar.module.scss';

export const NO_FEES_TEXT = 'There are currently no fees for this program.';

/* TournamentFeesSidebar */
export function TournamentFeesSidebar({
  tournamentData,
}: Readonly<{ tournamentData: Tournament }>) {
  const fees = buildFees(tournamentData);
  const registrationFees = convertRegFeesToNumbers(fees);
  const { showTeamPlayerFees, showTeamStaffFees } = tournamentData;

  return (
    <div className={styles.tournamentFeesSidebar}>
      <div className={styles.feesSidebarHeading}>
        Registration types and fees
      </div>
      {registrationFees.length === 0 ? (
        <NoFeesCard />
      ) : (
        <TournamentSidebarCards
          registrationFees={registrationFees}
          showTeamPlayerFees={showTeamPlayerFees}
          showTeamStaffFees={showTeamStaffFees}
        />
      )}
    </div>
  );
}
/* */

/* No Fees Card */
export function NoFeesCard() {
  return (
    <div className={styles.feesSidebarCard}>
      <span className={styles.noFees}>{NO_FEES_TEXT}</span>
    </div>
  );
}
/* */

/* Tournament Sidebar Cards */
export function TournamentSidebarCards({
  registrationFees,
  showTeamPlayerFees,
  showTeamStaffFees,
}: Readonly<FeesSidebarCardProps>) {
  const { getRequiredAddOnsByType } = useRegistrationAddOns();
  const requiredPlayerAddOns = getRequiredAddOnsByType('player');
  const requiredStaffAddOns = getRequiredAddOnsByType('staff');

  const registrationFeesData = compileRegistrationFeesData(
    registrationFees,
    requiredPlayerAddOns,
    requiredStaffAddOns,
    showTeamPlayerFees,
    showTeamStaffFees
  );
  return (
    <>
      {registrationFeesData.map((registrationFeesDatum, idx) => {
        return registrationFeesDatum ? (
          <TournamentSidebarCard
            addOnRangeDisplay={registrationFeesDatum.addOnRow}
            registrationType={registrationFeesDatum.registrationType}
            registrationTypeRangeDisplay={
              registrationFeesDatum.registrationTypeRow
            }
            registrationTypeLabel={registrationFeesDatum.registrationTypeLabel}
            totalCostRangeDisplay={registrationFeesDatum.totalCostRow}
            key={`${registrationFeesDatum.registrationTypeLabel}}-${idx}`}
          />
        ) : null;
      })}
    </>
  );
}
/* */

/* Tournament Sidebar Card */
export function TournamentSidebarCard({
  addOnRangeDisplay,
  registrationType,
  registrationTypeLabel,
  registrationTypeRangeDisplay,
  totalCostRangeDisplay,
}: Readonly<RegistrationFeeData>) {
  const [isAddOnsModalRendered, setIsAddOnsModalRendered] = useState(false);

  return (
    <>
      <div className={styles.feesSidebarCard}>
        <div className={styles.typeFeesRow}>
          <span>{registrationTypeLabel}</span>
          <span>{registrationTypeRangeDisplay}</span>
        </div>
        {addOnRangeDisplay ? (
          <div className={styles.addOnFeesRow}>
            <span>
              <button
                className={styles.displayAddOnsModalButton}
                onClick={() => setIsAddOnsModalRendered(true)}
              >
                Required add-ons
              </button>
            </span>
            <span>{addOnRangeDisplay}</span>
          </div>
        ) : null}
        <div className={styles.totalFeesRow}>
          <span>Total</span>
          <span>{totalCostRangeDisplay}</span>
        </div>
      </div>
      <AddOnsModal
        closeModal={() => setIsAddOnsModalRendered(false)}
        open={isAddOnsModalRendered}
        registrationType={registrationType}
      />
    </>
  );
}
/* */
